import React from 'react';
import { SUPPORTED_LOCALES, tFor } from '../../i18n/i18n.js';

// LocaleSwitch — segmented control in the header that lets the customer
// override the auto-detected locale. Two buttons (EN | TH), the active
// one is filled, the other is ghost. Renders nothing for locales we
// don't ship strings for.

export function LocaleSwitch({ locale, onChange }) {
  const t = tFor(locale);
  return (
    <div className="sp-locale" role="group" aria-label="Language">
      {SUPPORTED_LOCALES.map((code) => (
        <button
          key={code}
          type="button"
          className={'sp-locale__btn' + (locale === code ? ' is-active' : '')}
          aria-pressed={locale === code}
          onClick={() => onChange(code)}
        >
          {t(`header.locale.${code}`)}
        </button>
      ))}
    </div>
  );
}
